exports.SOCIAL_LINKS = {
    linkedin: "https://www.linkedin.com/in/calvin-noronha/",
    twitter: "https://twitter.com/calvinnrnha/",
    github: "https://github.com/CalvinNor/",
    medium: "https://medium.com/@calvin.nrnha/",
}
